{
  "version": 1,
  "asset_id": "d8720642-e7e8-46fa-9f4d-0eb0a601e2c9",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/d8720642-e7e8-46fa-9f4d-0eb0a601e2c9/ind-hvac-home-services-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/d8720642-e7e8-46fa-9f4d-0eb0a601e2c9/ind-hvac-home-services-640.webp",
  "original_filename": "ind-hvac-home-services-640.webp",
  "size": 8814,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:05Z"
}
